import { client, handleRequestBody } from "./client.ts";

export interface Construction {
	id: string;
	worksite_id: string;
	account_id: string;
	client_user_id?: string;
	name: string;
	description?: string;
	status: string;
	start_date?: string;
	expected_end_date?: string;
	cover_image_url?: string;
	technical_manager?: string;
	closed_at?: string;
	created_at: string;
	updated_at: string;
}

export interface ListConstructionsParams {
	page?: number;
	pageSize?: number;
	worksiteId?: string;
}

export interface ListConstructionsResponse {
	count: number;
	items: Construction[];
}

const MAX_PAGE_SIZE = 100;

export function listConstructions(
	params: ListConstructionsParams = {},
): Promise<ListConstructionsResponse> {
	return handleRequestBody(() =>
		client.get<ListConstructionsResponse>("/constructions", {
			params: {
				page: params.page,
				page_size: params.pageSize ?? MAX_PAGE_SIZE,
				worksite_id: params.worksiteId,
			},
		}),
	);
}

export interface CreateConstructionInput {
	worksiteId: string;
	name: string;
	description?: string;
	clientUserId?: string;
	startDate?: string;
	expectedEndDate?: string;
}

interface ConstructionResponse {
	construction: Construction;
}

export async function createConstruction(
	input: CreateConstructionInput,
): Promise<Construction> {
	const { construction } = await handleRequestBody(() =>
		client.post<ConstructionResponse>("/constructions", {
			worksite_id: input.worksiteId,
			client_user_id: input.clientUserId,
			name: input.name,
			description: input.description,
			start_date: input.startDate,
			expected_end_date: input.expectedEndDate,
		}),
	);
	return construction;
}

export interface UpdateConstructionInput {
	name?: string;
	description?: string;
	status?: string;
	startDate?: string;
	expectedEndDate?: string;
	technicalManager?: string;
}

export async function updateConstruction(
	id: string,
	input: UpdateConstructionInput,
): Promise<Construction> {
	const { construction } = await handleRequestBody(() =>
		client.patch<ConstructionResponse>(`/constructions/${id}`, {
			name: input.name,
			description: input.description,
			status: input.status,
			start_date: input.startDate,
			expected_end_date: input.expectedEndDate,
			technical_manager: input.technicalManager,
		}),
	);
	return construction;
}
